export class Role {

  createDate: Date = new Date();
  createdBy: string;
  description: string;
  id: number;
  isDeleted: boolean = false;
  name: string;
  status: number = 0;
  tenantId: number = 0;
  updateCount: number = 0;
  updateDate: Date = new Date();
  updatedBy: string;
}
